import { useLocation } from "react-router-dom";
import { ProgrammeContent } from "../../components/app";

export default function Programme() {
  let location = useLocation();

  return <>{location?.state?.page === "details" ? null : <ProgrammeContent />}</>;
}
